import { useMemo, type ReactElement } from 'react';
import { usePageBreadcrumb, usePageSidebar, useStrapiApi } from '@/hooks';
import { sidebarItems } from './sidebar';
import { getDepartamentos } from '@/services/strapi';
import { type StrapiBaseRequest, type DepartamentosPage, type Departamento } from '@/interfaces/strapi';
import { queryParams } from './queryParams';
import { DepartamentoItem } from '@/components/DepartamentoItem';
import { ROUTES } from '@/constants';

export const Departamentos = (): ReactElement => {
	const {
		loading: loadingPage,
		data: page,
		error: errorPage,
	} = useStrapiApi<DepartamentosPage, StrapiBaseRequest>(getDepartamentos, {
		autoFetch: true,
		params: queryParams,
	});

	usePageBreadcrumb([
		{ label: 'El Colegio', to: ROUTES.COLEGIO_PRESENTACION },
		{ label: 'Organización', to: ROUTES.COLEGIO_JUNTA_DIRECTIVA },
		{ label: 'Departamentos' },
	]);

	const sidebar = useMemo(() => sidebarItems, []);
	usePageSidebar(sidebar, true);

	if (loadingPage) return <div className="u-mt-md">Cargando…</div>;
	if (errorPage) return <div className="u-mt-md">No se pudo cargar la página.</div>;
	if (!page) return <div className="u-mt-md">No se encontró la página.</div>;

	return (
		<ul className="c-cnm-departamento__list">
			{page.departaments.map((item) => (
				<li key={item.id} className="c-cnm-departamento__list-item">
					<DepartamentoItem item={item} />
				</li>
			))}
		</ul>
	);
};
